/* Cloth-Vastr 3D luxury FX: sparkles, cursor, 3D reveals, split headings, tilt, magnetic buttons, parallax */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var designMode = document.documentElement.classList.contains('shopify-design-mode');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Sparkle canvas (gold dust drifting in 3D depth) ---------- */
  function sparkles() {
    if (reduce) return;
    var c = document.createElement('canvas');
    c.id = 'cv-sparkles';
    document.body.prepend(c);
    var ctx = c.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W, H, parts = [];
    var N = window.innerWidth < 750 ? 28 : 70;
    var mx = 0, my = 0;
    function size() {
      W = window.innerWidth; H = window.innerHeight;
      c.width = W * dpr; c.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function spawn(p, initial) {
      p.z = Math.random() * 0.9 + 0.1;              // depth 0.1..1
      p.x = Math.random() * W;
      p.y = initial ? Math.random() * H : H + 20;
      p.r = 0.6 + p.z * 2.2;
      p.vy = -(0.12 + p.z * 0.55);
      p.vx = (Math.random() - 0.5) * 0.25;
      p.tw = Math.random() * Math.PI * 2;
      p.hue = Math.random() < 0.8 ? 'g' : 'm';
      return p;
    }
    size();
    for (var i = 0; i < N; i++) parts.push(spawn({}, true));
    window.addEventListener('resize', size, { passive: true });
    window.addEventListener('pointermove', function (e) { mx = (e.clientX / W - 0.5); my = (e.clientY / H - 0.5); }, { passive: true });
    var scrollY = window.scrollY, lastScroll = scrollY;
    function frame() {
      ctx.clearRect(0, 0, W, H);
      scrollY = window.scrollY;
      var ds = scrollY - lastScroll; lastScroll = scrollY;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.tw += 0.04;
        p.y += p.vy - ds * p.z * 0.25;
        p.x += p.vx;
        if (p.y < -20 || p.y > H + 40 || p.x < -20 || p.x > W + 20) spawn(p, false);
        var px = p.x + mx * 40 * p.z, py = p.y + my * 30 * p.z;
        var a = (0.35 + 0.65 * Math.abs(Math.sin(p.tw))) * (0.35 + p.z * 0.65);
        var g = ctx.createRadialGradient(px, py, 0, px, py, p.r * 4);
        var col = p.hue === 'g' ? '246,223,168' : '232,90,150';
        g.addColorStop(0, 'rgba(' + col + ',' + a + ')');
        g.addColorStop(1, 'rgba(' + col + ',0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(px, py, p.r * 4, 0, Math.PI * 2); ctx.fill();
        if (p.z > 0.8) { // star glint
          ctx.strokeStyle = 'rgba(255,240,210,' + a * 0.6 + ')';
          ctx.lineWidth = 0.6;
          ctx.beginPath(); ctx.moveTo(px - p.r * 5, py); ctx.lineTo(px + p.r * 5, py); ctx.moveTo(px, py - p.r * 5); ctx.lineTo(px, py + p.r * 5); ctx.stroke();
        }
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ---------- Cursor glow + dot ---------- */
  function cursor() {
    if (!finePointer || reduce) return;
    var glow = document.createElement('div'); glow.id = 'cv-cursor';
    var dot = document.createElement('div'); dot.id = 'cv-cursor-dot';
    document.body.appendChild(glow); document.body.appendChild(dot);
    var x = 0, y = 0, gx = 0, gy = 0;
    window.addEventListener('pointermove', function (e) {
      x = e.clientX; y = e.clientY;
      document.body.classList.add('cv-has-pointer');
      dot.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      var t = e.target.closest && e.target.closest('a,button,product-card,.product-card,.cv-ring__card');
      document.body.classList.toggle('cv-hovering', !!t);
    }, { passive: true });
    document.addEventListener('pointerleave', function () { document.body.classList.remove('cv-has-pointer'); });
    (function loop() {
      gx += (x - gx) * 0.12; gy += (y - gy) * 0.12;
      glow.style.transform = 'translate3d(' + gx + 'px,' + gy + 'px,0)';
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Scroll progress ---------- */
  function progress() {
    var bar = document.createElement('div'); bar.id = 'cv-progress';
    document.body.appendChild(bar);
    function upd() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? window.scrollY / h : 0) + ')';
    }
    window.addEventListener('scroll', upd, { passive: true }); upd();
  }

  /* ---------- Split headings into words ---------- */
  function splitHeading(el) {
    if (el.dataset.cvSplit) return;
    el.dataset.cvSplit = '1';
    var idx = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (w) {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
            var outer = document.createElement('span'); outer.className = 'cv-w';
            var inner = document.createElement('span'); inner.textContent = w; inner.style.setProperty('--i', idx++);
            outer.appendChild(inner); frag.appendChild(outer);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
      });
    })(el);
    el.classList.add('cv-split');
  }

  /* ---------- 3D reveals ---------- */
  function reveals() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('cv-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    var sections = main.querySelectorAll(':scope > .shopify-section');
    sections.forEach(function (s, i) {
      s.classList.add('cv-stage');
      if (i === 0) return; // hero handled by slideshow
      var kids = s.querySelectorAll('product-card, .product-card, .cv-glass, .collection-card, .resource-list__item, .media-with-content__media, .media-with-content__content, .cv-ring-head, .cv-depth__copy, .cv-depth__scene');
      if (!kids.length) { s.firstElementChild && s.firstElementChild.classList.add('cv-reveal'); s.firstElementChild && io.observe(s.firstElementChild); }
      kids.forEach(function (k, j) {
        k.classList.add('cv-reveal');
        if (k.classList.contains('media-with-content__media')) k.classList.add(j % 2 ? 'cv-reveal--right' : 'cv-reveal--left');
        k.style.transitionDelay = Math.min(j % 8, 7) * 90 + 'ms';
        io.observe(k);
      });
    });
    main.querySelectorAll('h1, h2').forEach(function (h) {
      if (reduce) return;
      splitHeading(h); io.observe(h);
    });
    if (designMode) main.querySelectorAll('.cv-reveal, .cv-split').forEach(function (e) { e.classList.add('cv-in'); });
  }

  /* ---------- 3D tilt with glare ---------- */
  function tilt() {
    if (!finePointer || reduce) return;
    function bind(card) {
      if (card.dataset.cvTilt) return;
      card.dataset.cvTilt = '1';
      var glare = document.createElement('span'); glare.className = 'cv-glare'; card.appendChild(glare);
      var max = card.classList.contains('cv-glass') ? 8 : 12;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        card.style.transition = 'transform .12s linear, box-shadow .6s';
        card.style.transform = 'perspective(900px) rotateX(' + ((0.5 - py) * max) + 'deg) rotateY(' + ((px - 0.5) * max) + 'deg) translateZ(18px)';
        card.style.setProperty('--gx', px * 100 + '%'); card.style.setProperty('--gy', py * 100 + '%');
      });
      card.addEventListener('pointerleave', function () {
        card.style.transition = ''; card.style.transform = '';
      });
    }
    function scan() { document.querySelectorAll('product-card, .product-card, .cv-tilt, .cv-glass, .collection-card').forEach(bind); }
    scan();
    new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Magnetic buttons ---------- */
  function magnetic() {
    if (!finePointer || reduce) return;
    document.querySelectorAll('main .button, .cv-btn').forEach(function (b) {
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * 0.22 + 'px,' + (e.clientY - r.top - r.height / 2) * 0.3 + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- Hero parallax (content floats in depth with mouse + scroll) ---------- */
  function heroParallax() {
    if (reduce) return;
    var hero = document.querySelector('#MainContent > .shopify-section:first-child');
    if (!hero) return;
    var mx = 0, my = 0;
    window.addEventListener('pointermove', function (e) { mx = e.clientX / window.innerWidth - 0.5; my = e.clientY / window.innerHeight - 0.5; }, { passive: true });
    (function loop() {
      var s = Math.min(window.scrollY, 900);
      hero.querySelectorAll('.slide__content .group-block-content').forEach(function (c) {
        c.style.transform = 'perspective(1000px) translate3d(' + mx * -18 + 'px,' + (my * -12 + s * 0.25) + 'px,0) rotateY(' + mx * 4 + 'deg) rotateX(' + my * -4 + 'deg)';
        c.style.opacity = String(Math.max(0, 1 - s / 700));
      });
      hero.querySelectorAll('.slide__video, .slide__image').forEach(function (v) {
        v.style.transform = 'scale(1.08) translate3d(' + mx * 14 + 'px,' + (my * 10 + s * 0.12) + 'px,0)';
      });
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Generic depth layers [data-cv-depth] ---------- */
  function depthLayers() {
    if (reduce) return;
    var layers = document.querySelectorAll('[data-cv-depth]');
    if (!layers.length) return;
    var mx = 0, my = 0;
    window.addEventListener('pointermove', function (e) { mx = e.clientX / window.innerWidth - 0.5; my = e.clientY / window.innerHeight - 0.5; }, { passive: true });
    (function loop() {
      layers.forEach(function (l) {
        var d = parseFloat(l.dataset.cvDepth) || 1;
        var r = l.parentElement.getBoundingClientRect();
        var sp = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        l.style.setProperty('--cv-dx', mx * 40 * d + 'px');
        l.style.setProperty('--cv-dy', my * 30 * d + sp * -80 * d + 'px');
      });
      requestAnimationFrame(loop);
    })();
  }

  ready(function () {
    try { sparkles(); } catch (e) {}
    try { cursor(); } catch (e) {}
    try { progress(); } catch (e) {}
    try { reveals(); } catch (e) {}
    try { tilt(); } catch (e) {}
    try { magnetic(); } catch (e) {}
    try { heroParallax(); } catch (e) {}
    try { depthLayers(); } catch (e) {}
  });
})();
